import React, { useEffect } from 'react'
import { connect, useSelector } from 'react-redux'
import { fetchOpportunityInfo } from '../../actions/opportunityActions'
import MainNav from 'components/navigation/mainNav'
import { httpVerbConstants } from '../../constants/actionTypes'
import { fetchOpportunityInfo as consultantFetchOpportunityInfo } from '../../actions/consultantOpportunityActions'
import { logout } from '../../actions/authenticationActions'
import { msalApp } from '../../utils/authConfig'
import { updateAccount } from '../../actions/updateActions'
import { checkConsultant } from '../../helpers'

const CustomNavbar = ({
  accessToken,
  consultant,
  customer,
  isAuthenticated,
  opportunityId,
  dispatch,
  applicationRoles,
}) => {
  let headers = { accessToken: accessToken }
  useEffect(() => {
    if (isAuthenticated && opportunityId) {
      if (customer && customer.id) {
        //do nothing
      } else {
        if (checkConsultant()) {
          dispatch(
            consultantFetchOpportunityInfo(
              opportunityId,
              headers,
              httpVerbConstants.HTTP_GET
            )
          )
        } else {
          dispatch(fetchOpportunityInfo(opportunityId))
        }
      }
    } else {
      if (checkConsultant()) {
        window.localStorage.clear()
        msalApp.logout()
        //this.props.updateAccount(null)
        this.props.dispatch(updateAccount(null))
        window.location.href = '/consultant/login'
      } else {
        dispatch(logout())
        window.location.href = '/login'
      }
    }
  }, [])

  return (
    <MainNav
      applicationRoles={applicationRoles}
      customer={customer}
      consultant={consultant}
    />
  )
}

function mapStateToProps(state) {
  const { consultant, user: customer } = state
  const applicationRoles = state.applicationRoles
  const isAuthenticated = checkConsultant()
    ? state.auth.isAuthenticated
    : state.authentication.isAuthenticated
  const opportunityId = state.authentication.opportunityId
  const accessToken = state.auth.accessToken

  return {
    consultant,
    customer,
    isAuthenticated,
    opportunityId,
    accessToken,
    applicationRoles,
  }
}

export default connect(mapStateToProps)(CustomNavbar)
